window.__socialProofIntervals = window.__socialProofIntervals || {};

function renderIconicSocialProofFirst(component) {
  if (!component || component.dataset.rendered === "true") return;
  
  const settings = JSON.parse(component.dataset.settings);
  const blockId = component.dataset.blockId;
  const container = document.createElement("div");
  
  container.id = `iconic-social-proof-first-${blockId}`;
  container.className = "iconic-social-proof-container";
  
  const applyMargin = () => {
    const margin = window.innerWidth < 768 
      ? Math.round(settings.social_proof_margin_top_bottom * 0.75) 
      : settings.social_proof_margin_top_bottom;
    container.style.marginTop = margin + "px";
    container.style.marginBottom = margin + "px";
  };
  applyMargin();
  window.addEventListener("resize", applyMargin);
  
  const wrapper = document.createElement("div");
  wrapper.className = "iconic-social-proof-content";
  wrapper.style.cssText = `width:100%;background-color:${settings.bg_color};border:${settings.social_proof_box_border}px solid ${settings.social_proof_box_border_color};border-radius:${settings.social_proof_box_radius}px;display:flex;align-items:center;gap:12px;padding:0 12px`;
  
  const applyPadding = () => {
    const padding = window.innerWidth < 768 
      ? Math.round(settings.social_proof_padding_top_bottom * 0.75) 
      : settings.social_proof_padding_top_bottom;
    wrapper.style.paddingTop = padding + "px";
    wrapper.style.paddingBottom = padding + "px";
  };
  applyPadding();
  window.addEventListener("resize", applyPadding);
  
  const imagesContainer = document.createElement("div");
  imagesContainer.style.display = "flex";
  
  const images = [];
  for (let i = 1; i <= 4; i++) {
    const url = settings[`customer_image_${i}`];
    if (url) {
      images.push(createImage(i, url, settings));
      imagesContainer.appendChild(images[images.length - 1]);
    }
  }
  
  wrapper.appendChild(imagesContainer);
  
  if (settings.verified_name_1 || settings.verified_name_2 || settings.additional_text) {
    wrapper.appendChild(createText(settings));
  }
  
  container.appendChild(wrapper);
  component.appendChild(container);
  component.dataset.rendered = "true";
  
  if (settings.enable_carousel !== false && images.length >= 4) {
    initCarousel(imagesContainer, blockId, settings);
  }
}

function createImage(index, url, s) {
  const div = document.createElement("div");
  div.style.cssText = `position:relative;overflow:hidden;border:${s.img_border}px solid ${s.img_border_color};border-radius:${s.img_radius}px`;
  
  const updateSize = () => {
    const isMobile = window.innerWidth < 768;
    const size = isMobile ? s.social_proof_image_size_mobile : s.social_proof_image_size;
    div.style.width = size + "px";
    div.style.height = size + "px";
    div.style.zIndex = 6 - index;
    if (index > 1) div.style.marginLeft = (isMobile ? -8 : -12) + "px";
  };
  updateSize();
  window.addEventListener("resize", updateSize);
  
  const img = document.createElement("img");
  img.src = url;
  img.alt = `Profile ${index}`;
  img.loading = "lazy";
  img.style.cssText = "width:100%;height:100%;object-fit:cover;display:block";
  div.appendChild(img);
  return div;
}

function createText(s) {
  const div = document.createElement("div");
  div.style.cssText = `color:${s.social_proof_text_color};flex:1`;
  
  const updateFont = () => {
    const size = window.innerWidth < 768 ? s.social_proof_text_size_mobile : s.social_proof_text_size;
    div.style.fontSize = size + "px";
    div.style.minWidth = window.innerWidth < 768 ? "150px" : "200px";
  };
  updateFont();
  window.addEventListener("resize", updateFont);
  
  const badge = '<svg viewBox="0 0 24 24" style="width:1em;height:1em;display:inline-block;vertical-align:middle"><path fill-rule="evenodd" d="M21.007 8.27C22.194 9.125 23 10.45 23 12c0 1.55-.806 2.876-1.993 3.73.24 1.442-.134 2.958-1.227 4.05-1.095 1.095-2.61 1.459-4.046 1.225C14.883 22.196 13.546 23 12 23c-1.55 0-2.878-.807-3.731-1.996-1.438.235-2.954-.128-4.05-1.224-1.095-1.095-1.459-2.611-1.217-4.05C1.816 14.877 1 13.551 1 12s.816-2.878 2.002-3.73c-.242-1.439.122-2.955 1.218-4.05 1.093-1.094 2.61-1.467 4.057-1.227C9.125 1.804 10.453 1 12 1c1.545 0 2.88.803 3.732 1.993 1.442-.24 2.956.135 4.048 1.227 1.093 1.092 1.468 2.608 1.227 4.05Zm-4.426-.084a1 1 0 0 1 .233 1.395l-5 7a1 1 0 0 1-1.521.126l-3-3a1 1 0 0 1 1.414-1.414l2.165 2.165 4.314-6.04a1 1 0 0 1 1.395-.232Z" fill="#4C8AE7"/></svg>';
  
  let html = "";
  if (s.verified_name_1) html += `<span style="display:inline-flex;align-items:center;gap:2px">${s.verified_name_1} ${badge}</span>`;
  if (s.verified_name_2) html += `${html ? ", " : ""}<span style="display:inline-flex;align-items:center;gap:2px">${s.verified_name_2} ${badge}</span>`;
  if (s.additional_text) html += `${html ? " " : ""}<span>${s.additional_text}</span>`;
  
  div.innerHTML = html;
  return div;
}

function initCarousel(container, blockId, settings) {
  if (!container || container.dataset.animated === "true") return;
  
  const items = Array.from(container.querySelectorAll("div"));
  if (items.length <= 3) return;
  
  container.dataset.animated = "true";
  addStyles();
  
  const track = document.createElement("div");
  track.style.cssText = "display:flex;will-change:transform;position:relative";
  items.forEach(el => {
    el.style.cssText += ";margin-left:0;position:absolute;top:0";
    track.appendChild(el);
  });
  container.appendChild(track);
  
  const state = { visible: 3, step: 0, max: 0, current: 0, dir: 1, overlap: 0 };
  
  const measure = () => {
    const first = track.querySelector("div");
    if (!first) return;
    
    const w = first.getBoundingClientRect().width;
    state.overlap = window.innerWidth <= 768 ? -8 : -12;
    state.step = w;
    state.max = Math.max(0, items.length - state.visible);
    
    container.style.overflow = "hidden";
    container.style.width = w * state.visible + "px";
    
    items.forEach((el, i) => {
      el.style.left = i * state.step + "px";
      el.style.zIndex = "1";
    });
    
    track.style.width = w + (items.length - 1) * state.step + "px";
    track.style.height = w + "px";
    track.style.transform = `translateX(${-state.current * state.step}px)`;
    
    applyOverlap(track, state, items);
  };
  
  const animate = () => {
    if (state.max <= 0) return;
    
    const next = Math.max(0, Math.min(state.max, state.current + state.dir));
    
    if (state.dir === 1) {
      addAnim(items[state.current], "out");
      addAnim(items[next + state.visible - 1], "in");
    } else {
      addAnim(items[state.current + state.visible - 1], "out");
      addAnim(items[next], "in");
    }
    
    state.current = next;
    track.style.transition = "transform 500ms ease";
    track.style.transform = `translateX(${-state.current * state.step}px)`;
    
    setTimeout(() => applyOverlap(track, state, items), 20);
    
    if (state.current === state.max) state.dir = -1;
    else if (state.current === 0) state.dir = 1;
  };
  
  measure();
  
  let timer;
  window.addEventListener("resize", () => {
    clearTimeout(timer);
    timer = setTimeout(measure, 150);
  });
  
  const interval = setInterval(animate, (settings.animation_speed || 3) * 1000);
  window.__socialProofIntervals[blockId] = interval;
}

function addAnim(el, type) {
  if (!el) return;
  const cls = `iconic-rotate-${type}`;
  el.classList.remove(cls);
  void el.offsetWidth;
  el.classList.add(cls);
  el.addEventListener("animationend", function handler() {
    el.classList.remove(cls);
    el.removeEventListener("animationend", handler);
  });
}

function applyOverlap(track, state, items) {
  const left = items[state.current];
  const mid = items[state.current + 1];
  const right = items[state.current + 2];
  
  if (!left || !mid || !right) return;
  
  left.style.zIndex = "1";
  mid.style.zIndex = "2";
  right.style.zIndex = "3";
  
  const overlapAbs = Math.abs(state.overlap);
  const baseL = state.current * state.step;
  const baseM = (state.current + 1) * state.step;
  const baseR = (state.current + 2) * state.step;
  
  left.style.left = baseL + "px";
  mid.style.left = baseM - Math.round(overlapAbs / 2) + "px";
  right.style.left = baseR + state.overlap + "px";
}

function addStyles() {
  if (document.getElementById("iconic-anim")) return;
  
  const style = document.createElement("style");
  style.id = "iconic-anim";
  style.textContent = `
    @keyframes iconicRotateOut{0%{transform:rotate(0) scale(1);opacity:1}100%{transform:rotate(-10deg) scale(.9);opacity:0}}
    @keyframes iconicRotateIn{0%{transform:rotate(10deg) scale(.9);opacity:0}100%{transform:rotate(0) scale(1);opacity:1}}
    .iconic-rotate-out{animation:iconicRotateOut 450ms ease both}
    .iconic-rotate-in{animation:iconicRotateIn 450ms ease both}
  `;
  document.head.appendChild(style);
}

function stopCarousel(blockId) {
  if (window.__socialProofIntervals[blockId]) {
    clearInterval(window.__socialProofIntervals[blockId]);
    delete window.__socialProofIntervals[blockId];
  }
}

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".iconic-social-proof-first-js").forEach(renderIconicSocialProofFirst);
});

if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  ["shopify:section:load", "shopify:section:select", "shopify:block:select"].forEach(evt => {
    document.addEventListener(evt, (e) => {
      e.target.querySelectorAll(".iconic-social-proof-first-js").forEach(block => {
        stopCarousel(block.dataset.blockId);
        block.innerHTML = "";
        block.dataset.rendered = "false";
        renderIconicSocialProofFirst(block);
      });
    });
  });
}

window.addEventListener("beforeunload", () => {
  Object.keys(window.__socialProofIntervals).forEach(stopCarousel);
});